export default __webpack_public_path__ + "static/media/1.cf5d5fd1.jpg";